//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { maxLength } from 'vuelidate/lib/validators';

export default {
	data () {
		return {
			showModal: false,
		};
	},

	async fetch ({ params, $axios, store }) {
		const response = await $axios.get('/party/party-themes/read/' + params.slug);
		await store.commit('party/SET_PARTY_THEME', response.data.payload);
		await store.commit('party/SET_PARTY_THEME_ITEMS', response.data.payload.items);
	},

	validations () {
		return {
			partyInvite: {
				inviteName: {
					maxLength: maxLength(40),
				},

				inviteWhen: {
					maxLength: maxLength(40),
				},

				inviteWhere: {
					maxLength: maxLength(40),
				},

				inviteWho: {
					maxLength: maxLength(40),
				},

				inviteNote: {
					maxLength: maxLength(120),
				},
			},
		};
	},

	head () {
		return {
			title: this.$config.webTitle[this.$i18n.locale] + ' - Chystám party',
			meta: [
				{
					name: 'description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
				{
					property: 'og:title',
					content: this.$config.webTitle[this.$i18n.locale],
				},
				{
					property: 'og:description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
			],
		};
	},

	computed: {
		...mapState({
			partyItemDetail: (state) => state.party.partyTheme,
			partyItemsDetail: (state) => state.party.partyThemeItems,
			partyInvite: (state) => state.partyItem.inviteForm,
			partyItem: (state) => state.partyItem.partyItem,
		}),
	},

	methods: {
		toggleModal () {
			this.showModal = !this.showModal;
		},

		updateField (fieldName, updatedValue) {
			this.$store.commit('partyItem/UPDATE_FIELD_INVITE_FORM', { fieldName, updatedValue });
		},

		// Pošle uživatele na podstránku s náhledem čepice
		handlePartyItem (item) {
			this.$store.commit('partyItem/UPDATE_FIELD_PARTY_ITEM', item);
			if (item && item.type === 'item') {
				this.$router.push(this.$route.path + '/' + item.slug);
			}
			else {
				return;
			}
		},

		// Pošle uživatele na podstránku s náhledem pozvánky
		handlePartyInvite () {
			if (this.$v.$invalid) {
				this.$v.$touch();
				// console.log(this.$v);
			}
			else if (this.partyItem) {
				this.$axios.post('/party/generate-custom-pdf-file/' + this.partyItem.slug, {
					infoName: this.partyInvite.inviteName,
					infoWhen: this.partyInvite.inviteWhen,
					infoWhere: this.partyInvite.inviteWhere,
					infoWho: this.partyInvite.inviteWho,
					text: this.partyInvite.inviteNote,
				}).then(inviteResponse => {
					this.$store.commit('partyItem/UPDATE_FIELD_INVITE', inviteResponse.data.payload);
				});
				this.$router.push(this.$route.path + '/' + this.partyItem.slug);
			}
		},
	},
};
